import React from 'react';
import SecondButtonContainer from './SecondButtonContainer';
import GdprTextContainer from './GdprTextContainer';

export default function LinkOnlyBanner({ linkBtnApplication, fallbackButtonText }) {
    return (
        <>
            <SecondButtonContainer
                buttonText={linkBtnApplication.LinkText || fallbackButtonText}
                buttonLink={linkBtnApplication.Url}
            />
            <GdprTextContainer />
        </>
    );
}
